import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const t = () => /* @__PURE__ */ o.jsx("svg", { viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ o.jsx(
  "path",
  {
    d: "M57.213 58.263c-5.403-.835-8.78-4.683-13.14-10.162-2.102-2.64-4.307-5.552-7.008-8.168 4.209-4.098 7.267-8.865 10.502-12.33 3.045-3.239 5.73-5.351 9.65-5.943v9.063l22.78-15.362L57.213 0v9.337c-10.071.937-16.434 8.373-20.908 14.13-2.473 3.154-4.635 5.957-6.67 7.717-2.066 1.76-3.7 2.57-6.07 2.612H0V46.12h23.562c2.37.035 4.01.845 6.082 2.613 3.075 2.616 6.317 7.675 10.71 12.562 3.956 4.43 9.535 8.661 16.862 9.33V80L80 64.65 57.216 49.297z",
    fill: "currentColor"
  }
) });
export {
  t as S
};
